import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { dataRaw } from "../data-fault.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  scales: {
    x: {
      stacked: true,
      ticks: {
        precision: 0,
        color: "#d7d7d7",
      },
      grid: {
        color: "#4b4b4b",
      },
    },
    y: {
      stacked: true,
      ticks: {
        precision: 0,
        color: "#d5d5d5",
      },
      grid: {
        color: "#4b4b4b",
      },
    },
  },
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      color: "#d7d1ff",
      text: "Predicted Fault",
    },
  },
};

function App({ assetId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    const dataFilter = dataRaw[assetId];

    const labels = [];
    const datas = [];
    const data_02 = [];
    const data_03 = [];
    const data_04 = [];
    const data_06 = [];
    const data_07 = [];
    const data_08 = [];
    const data_1 = [];
    dataFilter.map((item) => {
      let quarter = item["Year"];
      labels.push(quarter);
      data_02.push(item["0.2"]);
      data_03.push(item["0.3"]);
      data_04.push(item["0.4"]);
      data_06.push(item["0.6"]);
      data_07.push(item["0.7"]);
      data_08.push(item["0.8"]);
      data_1.push(item["1"]);
    });

    const data = {
      labels,
      datasets: [
        {
          label: "0.2 Severity",
          data: data_02,
          backgroundColor: "#110889",
        },
        {
          label: "0.3 Severity",
          data: data_03,
          backgroundColor: "#4b02a0",
        },
        {
          label: "0.4 Severity",
          data: data_04,
          backgroundColor: "#7d08a6",
        },
        {
          label: "0.6 Severity",
          data: data_06,
          backgroundColor: "#bc3586",
        },
        {
          label: "0.7 Severity",
          data: data_07,
          backgroundColor: "#d7576a",
        },
        {
          label: "0.8 Severity",
          data: data_08,
          backgroundColor: "#f79640",
        },
        {
          label: "1 Severity",
          data: data_1,
          backgroundColor: "#f0f921",
        },
      ],
    };
    setData(data);
  }, [assetId]);

  return data ? <Bar options={options} data={data} /> : null;
}
export default App;
